import dayjs from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const POSSIBLE_FORMATS = [
  'h:mm A',   // 2:39 AM
  'hh:mm A',  // 02:39 AM
  'h:mm a',   // 2:39 pm
  'hh:mm a',  // 02:39 pm
  'h:mmA',   // 2:39AM
  'hh:mmA',  // 02:39AM
  'h:mma',   // 2:39pm
  'hh:mma',  // 02:39pm
  'hA',       // 3PM
  'ha',       // 2am
  'hhA',      // 02PM
  'hha',      // 08am
  'hh A',     // 04 PM
  'h A',      // 3 PM
  'h a',      // 11 pm
  'hh a',     // 04 pm
  'HH:mm',    // 03:31
  'H:mm',     // 22:21
  'HH',       // 04
  'H',        // 12
];

export const timeFormatValidation = (time) => {
  if (!time) return false;
  // Check various format to see if value is a valid time.
  if (dayjs(time, 'HH:mm:ss').isValid()) {
    return time;
  }
  const dayObject = dayjs(time, POSSIBLE_FORMATS, true);
  if (dayObject.isValid()) {
    return dayObject.format('HH:mm:ss');
  }

  return false;
};

export const convertTimeView = (time, timeFormat) => {
  if (!time)
    return;

  const dayObject = dayjs(time, 'HH:mm:ss');

  switch (timeFormat) {
    case '12':
      return dayObject.format('h:mm A');
    case '24':
      return dayObject.format('HH:mm');
    default:
      return dayObject.format('h:mm A');
  }
};

export const getTimeList = (timeFormat = '24') => {
  const timeList = [];
  const hours = new Array(Number(timeFormat)).fill(0);
  const minutes = ['00', '15', '30', '45'];
  const timeFormats = timeFormat === '12' ? [' AM', ' PM'] : [''];

  timeFormats.forEach((format, formatIndex) => {
    hours.forEach((item, index) => {
      minutes.forEach(minute =>  timeList.push({
        label: `${format && index === 0 ? 12 : index}:${minute}${format}`,
        value: `${index + 12 * formatIndex < 10 ? '0' : ''}${index + 12 * formatIndex}:${minute}:00`,
      }));
    });
  });

  return timeList;
};

export const compareTime = (a, b) => {
  const _a = dayjs(a, 'HH:mm:ss');
  const _b = dayjs(b, 'HH:mm:ss');
  if (_a.isBefore(_b)) {
    return 1;
  }
  if (_a.isSame(_b)) {
    return 0;
  }
  if (_a.isAfter(_b)) {
    return -1;
  }
};
